// extracted by mini-css-extract-plugin
module.exports = {"btn":"categories_btn__OYU9V","selected":"categories_selected__MsB3W"};